import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AccountService } from './account.service';

@Injectable()
export class SubscriptionNotificationService {
  sub: Subscription;

  public planName: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  // -------------------------------------------------------------------
  constructor() {}

}
